import React, { useEffect, useReducer, useState } from "react";
import { Dialog } from "primereact/dialog";
import FactCheckIcon from "@mui/icons-material/FactCheck";
import { Box, Button, Alert, Typography } from "@mui/material";
import { Dropdown } from "primereact/dropdown";
import MultiSelect from "../FormsQuestions/MultiSelect";
import TrueFalse from "../FormsQuestions/TrueFalse";
import {
  initialState,
  questionReducer,
} from "context/quizzesQuestion/questionReducer";
import { types } from "context/types/types";
import { startFetchQuestions } from "actions/question";
import GetAllQuestions from "../GetAllQuestions";
import { fetchWithToken } from "helpers/fetch";
import { endPoints } from "const/endPoints";
import Toast from "components/common/Popup/Toast";

const ModalQuestionAnswer = ({ quizId }) => {
  //** Modal **/
  const [display, setDisplay] = useState(false);
  const onClick = () => {
    setDisplay(true);
  };
  const onHide = () => {
    setDisplay(false);
  };

  //** Opcion seleccionada **/
  const [selected, setSelected] = useState(null);

  const onOptionChange = (e) => {
    setSelected(e.value);
  };

  //*Reducer quizQuestion
  const [questions, dispatch] = useReducer(questionReducer, initialState);
  const [flag, setFlag] = useState(true);
  
  //*Points redistribution
  const [redistributing, setRedistributing] = useState(false);
  const [pointsSummary, setPointsSummary] = useState(null);

  //*Get all Questions
  useEffect(() => {
    const getAllQuestions = async () => {
      if (flag) {
        dispatch({
          type: types.questionStartFetch,
          payload: {},
        });
        const body = await startFetchQuestions(quizId);
        if (body.statusCode) {
          dispatch({
            type: types.questionFetchError,
            payload: {},
          });
        } else {
          dispatch({
            type: types.questionFetch,
            payload: body,
          });
        }
      }
    };
    getAllQuestions();
    setFlag(false);
  }, [flag]);

  //*Get points summary when modal opens
  useEffect(() => {
    if (display && quizId) {
      getPointsSummary();
    }
  }, [display, quizId]);

  const getPointsSummary = async () => {
    try {
      const response = await fetchWithToken(`${endPoints.get_quiz_points_summary}/${quizId}`);
      if (response.status === 200) {
        const data = await response.json();
        setPointsSummary(data);
      }
    } catch (error) {
      console.error('Error getting points summary:', error);
    }
  };

  const redistributePoints = async () => {
    setRedistributing(true);
    try {
      const response = await fetchWithToken(
        `${endPoints.redistribute_quiz_points}/${quizId}`,
        {},
        'PUT'
      );
      
      if (response.status === 200) {
        Toast("success", "Puntos redistribuidos automáticamente");
        setFlag(true); // Refresh questions list
        getPointsSummary(); // Update points summary
      } else {
        const data = await response.json();
        Toast("error", data.message || "Error redistribuyendo puntos");
      }
    } catch (error) {
      console.error('Error redistributing points:', error);
      Toast("error", "Error redistribuyendo puntos");
    } finally {
      setRedistributing(false);
    }
  };

  const optionsItems = [
    { label: "Verdadero y Falso", value: 1 },
    { label: "Seleccion Simple", value: 2 },
  ];
  return (
    <>
      <button
        onClick={() => onClick("displayBasic")}
        style={{
          margin: "0px",
          padding: "0px",
          background: "none",
          border: "none",
          cursor: "pointer",
        }}
      >
        <FactCheckIcon color="primary" />
      </button>

      <Dialog
        header="Crear preguntas del Quiz"
        visible={display}
        style={{ width: "85vw", maxWidth: "1200px", height: "85vh" }}
        onHide={() => onHide("displayBasic")}
        draggable={false}
        resizable={false}
      >
        <Box
          sx={{
            display: "flex",
            flexDirection: "column",
            justifyContent: "center",
            alignItems: "center",
          }}
        >
          <span style={{ fontSize: "20px", margin: "10px 0px" }}>
            Selecciona el tipo de pregunta que deseas crear:
          </span>

          <Dropdown
            value={selected}
            options={optionsItems}
            onChange={onOptionChange}
            showClear={true}
            placeholder="Elija una opcion"
          />
          <Box
            sx={{
              margin: "5px 0px",
              width: "100%",
              padding: "0px",
            }}
          >
            {selected === 1 && (
              <TrueFalse
                dispatch={dispatch}
                quizId={quizId}
                setSelected={setSelected}
                setFlag={setFlag}
              />
            )}
            {selected === 2 && (
              <MultiSelect
                dispatch={dispatch}
                quizId={quizId}
                setSelected={setSelected}
                setFlag={setFlag}
              />
            )}
            {!selected && (
              <>
                {/* Points Summary and Redistribution */}
                {pointsSummary && questions.questions.length > 0 && (
                  <Box sx={{ 
                    mb: 2, 
                    p: 2, 
                    border: '1px solid #ddd', 
                    borderRadius: '8px',
                    backgroundColor: pointsSummary.totalPoints !== 20 ? '#fff3cd' : '#d4edda'
                  }}>
                    <Typography variant="h6" sx={{ mb: 1 }}>
                      Resumen de Puntos del Quiz
                    </Typography>
                    <Typography variant="body2" sx={{ mb: 1 }}>
                      <strong>Total de puntos asignados:</strong> {pointsSummary.totalPoints}/20
                    </Typography>
                    <Typography variant="body2" sx={{ mb: 1 }}>
                      <strong>Número de preguntas:</strong> {pointsSummary.questionCount}
                    </Typography>
                    
                    {pointsSummary.totalPoints !== 20 && (
                      <>
                        <Alert severity="warning" sx={{ mb: 2 }}>
                          <Typography variant="body2">
                            ⚠️ <strong>Problema detectado:</strong> Las preguntas existentes tienen puntos 
                            por defecto que no suman exactamente 20. 
                            <br/>
                            <strong>Solución:</strong> Puedes redistribuir automáticamente los 20 puntos 
                            de forma equitativa entre todas las preguntas.
                          </Typography>
                        </Alert>
                        
                        <Button
                          variant="contained"
                          color="primary"
                          onClick={redistributePoints}
                          disabled={redistributing}
                          sx={{ mb: 1 }}
                        >
                          {redistributing ? 'Redistribuyendo...' : 'Redistribuir Puntos Automáticamente'}
                        </Button>
                        
                        <Typography variant="caption" display="block" sx={{ color: '#666' }}>
                          Esto asignará {(20 / pointsSummary.questionCount).toFixed(2)} puntos a cada pregunta
                        </Typography>
                      </>
                    )}
                    
                    {pointsSummary.totalPoints === 20 && (
                      <Alert severity="success">
                        ✅ Los puntos están correctamente distribuidos (20/20)
                      </Alert>
                    )}
                  </Box>
                )}

                {/* Questions List */}
                {questions.questions.map((item, i) => {
                  return (
                    <GetAllQuestions
                      key={item.id}
                      questions={item}
                      dispatch={dispatch}
                      quizId={quizId}
                      i={i}
                      setFlag={setFlag}
                    />
                  );
                })}
              </>
            )}
          </Box>
        </Box>
      </Dialog>
    </>
  );
};

export default ModalQuestionAnswer;
